import React from 'react';
import {dsnCN} from "../../../hooks/helper";

function MenuContent({className}) {
    const socialData = [
        {link: "https://www.instagram.com/cybernauticstech/", name: "Instagram"},
        {link: "https://www.facebook.com/CybernauticsTech", name: "Facebook"},
        {link: "https://www.linkedin.com/company/86323801", name: "Linkedin."},
    ];
    return (
        <div className={dsnCN('container-content  d-flex flex-column justify-content-center', className)}>
            <div className="nav__info">
                <div className="nav-content">
                    <h5 className="sm-title-block mb-10">Office</h5>
                    <p>
                    CYBERNAUTICSTECH, 6TH FLOOR, D-107, PHASE 7  INDUSTRIAL AREA,SECTOR 73,MOHALI, 160055
                    </p>

                </div>
                <div className="nav-content mt-30">
                    <h5 className="sm-title-block mb-10">Contact</h5>
                    <p className="links over-hidden mb-1">
                        <a className="link-hover" href="tel:+91 7300663142" data-hover-text="+91 7300663142">
                            +91 7300663142
                        </a>
                        &emsp;
                        <a className="link-hover" href="tel:+91 7837912354" data-hover-text="+91 7837912354">
                            +91 7837912354
                        </a>
                    </p>
                    <p className="links over-hidden">
                        <a className="link-hover" href="mailto:info@dsngrid.com"
                           data-hover-text="info@dsngrid.com">INFO@CYBERNAUTICSTECH.COM</a>
                    </p>
                </div>
            </div>
            <div className="nav-social nav-content mt-30">
                <div className="nav-social-inner p-relative">
                    <h5 className="sm-title-block mb-10">Follow us</h5>
                    <ul>
                        {socialData.map((item, index) =>
                            <li key={index}>
                                <a href={item.link} target="_blank" rel="nofollow noopener noreferrer">{item.name}</a>
                            </li>)}
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default MenuContent;